<app-dialog-template [bodyHasNegativeSpaceX]="true">
  <app-dialog-template-header>
    <app-dialog-template-title>{{ objectDefinition | objectName }}</app-dialog-template-title>
    <app-dialog-template-header-actions></app-dialog-template-header-actions>
  </app-dialog-template-header>

  <app-dialog-template-body [hasSpaceY]="false">
    <app-object-view
      [viewAsPage]="false"
      [settings]="settings"
      (objectDefinitionChanged)="onObjectDefinitionChanged($event)">
    </app-object-view>
  </app-dialog-template-body>
</app-dialog-template>
